import { CommonHeaders } from './commonHeaders';

export class BifrostHeaders extends CommonHeaders {
  public constructor(apiKey: string) {
    super(apiKey);

    this.set('X-Api-Key', apiKey);
    this.set('Authorization', 'Bearer {accessToken}');
  }
}
